import React, { useState, } from 'react';
import right from './img/icons/right-chevron.png';
import left from './img/icons/left-chevron.png';
import './MayWant.css';
import { useStateValue } from './StateProvider';
import MayWantProduct from './MayWantProduct';
import { useEffect } from 'react';
import axios from 'axios';

function MayWant() {
    const [{ basket}, dispatch] = useStateValue();
    const [product, setProduct] = useState([]);
    var match = '';
    const matchid = [];
    
    

    function getMatch(item) {
        match += item.title + " ";
        matchid.push(item.id);
    }

    function getCheck(pro) {

        setProduct(
            ...product,
            pro.filter(item => !matchid.includes(item.id))
        )
    }
    

    useEffect(() => {

        basket.map(getMatch)

        axios
            .get('https://toycityzimbabwe.com/backend/getMatch.php', {params :{match}})
            .then((res) => {
                getCheck(res.data)
            })
            .catch( error => {
                console.log(error)
            });
      
    }, []);

    function buttonRight(id){
        document.getElementById(id).scrollLeft += 80;
    };
    
    function buttonLeft(id){
        document.getElementById(id).scrollLeft -= 80;
    };

    return (
        <div className="maywant">
            <main>
                <div className='slide-container'>
                <img className='arrow arrow-track' id='slide-left' src={left} onClick={() => {buttonLeft("slider")}} alt='left-arrow' />
                <section className='container' id="slider">
                {
                    product.map(item => (
                            <MayWantProduct 
                                id = {item.id}
                                title={item.name}
                                price={item.price} 
                                img={item.img}
                            />
                    ))
                }
                </section>
                <img className='arrow arrow-track' id='slide-right' src={right} onClick={() => {buttonRight("slider")}} alt='right-arrow'/>
                </div>
            </main>
        </div>
    )
}

export default MayWant;
